import React, { FC, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { AnswerTypes } from 'types';

import Button from 'components/Button';
import Header from 'components/Header';

import sendAnalyticsEvent from 'utils/sendAnalyticsEvent';
import hexToRGB from 'utils/hexToRgb';

const Divider: FC<AnswerTypes> = (props) => {
    const {
        lengthOnboarding,
        title,
        buttonText,
        handleSwitchToNextScreen,
        logoUrl,
        handleSwitchToPrevScreen,
        image,
        logoLink,
        id,
    } = props;
    const [backgroundImag, setBackgroundImag] = useState('');

    useEffect(() => {
        setBackgroundImag(image || '');
    }, [image]);

    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const quizScreenFromUrl = Number(params.get('screen'));

    const mainColor = document.documentElement.style.getPropertyValue('--main-bg-color');

    const handleOnClick = () => {
        sendAnalyticsEvent({
            eventName: 'page_completed',
            data: {
                page_number: quizScreenFromUrl,
                question: id,
            },
        });
        handleSwitchToNextScreen();
    };

    return (
        <section className="divider">
            <Header
                logoUrl={logoUrl}
                handleSwitchToPrevScreen={handleSwitchToPrevScreen}
                lengthOnboarding={lengthOnboarding}
                logoLink={logoLink}
            />
            <div
                className="divider__wrapper"
                style={{
                    backgroundImage: `radial-gradient(46.71% 47.78% at 50% 50%, rgba(0, 0, 0, 0) 38%, ${hexToRGB(mainColor, '1')} 100%), url(${backgroundImag})`,
                }}
            >
                {title && <h2 className="divider__title" dangerouslySetInnerHTML={{ __html: title }} />}
                {buttonText && <Button onClick={handleOnClick} text={buttonText} />}
            </div>
        </section>
    );
};

export default Divider;
